import gql from "graphql-tag"

const GET_SHIPPING_FEE_MODIFICATION = gql`
  query orderModificationShippingFees($modificationId: ID!) {
    Order {
      orderModificationShippingFees(modificationId: $modificationId) {
        id
        orderId
        started
        completed
        failed
        created
        updated
        restarts
        restarted
        revision
        type
        oldTotals {
          subTotal
          discountTotal
          grandTotal
          shippingTotal
          giftCardTotal
          bonusTotal
          voucherTotal
          taxTotal
        }
        newTotals {
          subTotal
          discountTotal
          grandTotal
          shippingTotal
          giftCardTotal
          bonusTotal
          voucherTotal
          taxTotal
        }
        giftCardProvider {
          providerName
          providerId
          status {
            current
          }
        }
        paymentProvider {
          providerName
          providerId
          status {
            current
          }
        }
        bonusProvider {
          providerName
          providerId
          status {
            current
          }
        }
        promotionProvider {
          providerName
          providerId
        }
        shippingProvider {
          providerName
          providerId
          status {
            current
          }
        }
        voucherProvider {
          providerId
          providerName
        }
        reason {
          code
          cause
        }
        orderReference
        shippingFees {
          modificationType
          data {
            ... on ShippingFeeModificationUpdateData {
              id
              price {
                salePriceAmount
                basePriceAmount
                discountAmount
              }
            }
          }
        }
      }
    }
  }
`

export default GET_SHIPPING_FEE_MODIFICATION
